import { Drawer, Collapse } from 'antd'
import BridgelinxLogo from '../../logo.png'
import { useNavigate } from 'react-router-dom'
import Icon from '@mdi/react'
import { SidebarEnum } from '../../utils/Enums'
import { useParams, useLocation } from 'react-router-dom'
import { useEffect, useState } from 'react'
import { mdiChevronRight } from '@mdi/js'
import { RBACSwitch } from '../../utils/Functions'

const { Panel } = Collapse

const NavDrawer = (props) => {
	const { collapseMenu, setCollapseMenu, user } = props

	const navigate = useNavigate()
	const { orderType } = useParams()
	const { pathname } = useLocation()
	const [selectedTab, setSelectedTab] = useState([])
	const [expandedKeys, setExpandedKeys] = useState([])

	useEffect(() => {
		setSelectedTab([pathname?.split('/')?.[1]])
		setExpandedKeys([pathname?.split('/')?.[1]])
	}, [pathname])

	return (
		<Drawer className='!p-0' placement='left' open={collapseMenu} width={300} closable={false} onClose={(collapseMenu) => setCollapseMenu(!collapseMenu)}>
			<div className='w-full flex flex-col p-0'>
				<div className='my-6 mx-[30px]'>
					<img className=' h-auto w-1/2' src={BridgelinxLogo} alt='' />
					<div className='text-secondary-400 tracking-wider text-[10px] font-medium'>Bilty OPS</div>
				</div>
				<Collapse
					size='small'
					ghost={true}
					bordered={false}
					accordion={true}
					className=' !bg-white'
					expandIconPosition='end'
					onChange={(keyArray) => setExpandedKeys(keyArray)}
					defaultActiveKey={selectedTab?.includes('biltyManagement') ? ['biltyManagement'] : null}
				>
					{Object.values(SidebarEnum)?.map((section) => {
						return (
							RBACSwitch(user?.userType, section?.key, 'collections') && (
								<Panel
									key={section?.key}
									showArrow={false}
									onClick={(e) => {
										if (!section?.children) {
											navigate(`../${section?.path}`)
											setCollapseMenu(!collapseMenu)
										} else {
											e.stopPropagation()
										}
									}}
									header={
										<>
											<hr className='border-dotted border-t-2 border-black-75' />
											<div className='flex flex-row w-full items-center justify-between my-auto !h-14 !px-7'>
												<div className='flex flex-row items-center'>
													{section.icon && (
														<Icon
															path={section.icon}
															size={0.9}
															className={`${selectedTab?.includes(section?.key) ? 'text-primary-800 font-semibold' : 'text-black-300'} mr-3`}
														/>
													)}
													<div className={`${selectedTab?.includes(section?.key) ? 'text-primary-800 font-semibold' : 'text-black-300 font-normal'} tracking-wide`}>
														{section?.text}
													</div>
												</div>
												{section?.children && (
													<div className='self-center'>
														<Icon
															className={`text-black-200 transition-all !duration-700 ${expandedKeys?.includes(section?.key) ? 'rotate-90' : 'rotate-0'}`}
															path={mdiChevronRight}
															size={1}
														/>
													</div>
												)}
											</div>
											{expandedKeys?.includes(section?.key) && section?.children && <hr className='border-dotted border-t-2 border-black-75' />}
										</>
									}
								>
									{section?.children && (
										<div className='py-3 px-6'>
											{section?.children?.map((page) => {
												return (
													<div
														key={page?.key}
														className={`flex flex-row px-6 h-11 justify-start items-center cursor-pointer ${orderType === page?.key ? 'bg-background rounded-full' : ''}`}
														onClick={() => {
															navigate(`../${page?.path}`)
															setCollapseMenu(!collapseMenu)
														}}
													>
														<Icon className={`${orderType === page?.key ? 'text-primary-800 font-semibold' : 'text-black-300'} mr-3`} path={page.icon} size={0.8} />
														<p className={`${orderType === page?.key ? 'text-primary-800 font-semibold' : 'text-black-300 font-normal'} tracking-wide`}>{page?.text}</p>
													</div>
												)
											})}
										</div>
									)}
								</Panel>
							)
						)
					})}
				</Collapse>
				<hr className='border-dotted border-t-2 border-black-75' />
			</div>
		</Drawer>
	)
}

export default NavDrawer
